export const categories = [
  {
    id: "trend",
    name: "趋势分析软件",
    shortName: "趋势分析",
    icon: "ri-line-chart-line",
    tone: "primary",
    desc: "面向中高级投资者的行情与趋势分析工具，覆盖伦敦金、现货黄金、黄金期货等多市场，提供多周期K线、技术指标与智能信号，帮助判断趋势方向与进出场时机。",
    subCategories: ["实时行情", "技术指标", "智能预警"],
  },
  {
    id: "monitor",
    name: "价格监控APP",
    shortName: "价格监控",
    icon: "ri-notification-3-line",
    tone: "accent",
    desc: "轻量级金价监控应用，支持到价提醒、涨跌推送与走势追踪，随时随地掌握黄金实时报价，不错过任何一次关键价格波动。",
    subCategories: ["到价提醒", "涨跌推送", "走势追踪"],
  },
  {
    id: "finance",
    name: "黄金理财工具",
    shortName: "理财工具",
    icon: "ri-hand-coin-line",
    tone: "secondary",
    desc: "聚焦黄金积存、定投与资产配置的理财助手，提供收益测算、定投计划与持仓管理，让黄金资产的长期配置更简单清晰。",
    subCategories: ["定投计划", "收益测算", "持仓管理"],
  },
  {
    id: "news",
    name: "行情资讯平台",
    shortName: "行情资讯",
    icon: "ri-newspaper-line",
    tone: "primary",
    desc: "聚合黄金市场快讯、机构研报与专家观点的资讯平台，用最短时间读懂美联储政策、避险情绪与金价驱动逻辑。",
    subCategories: ["实时快讯", "深度研报", "专家观点"],
  },
];